import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { Detalle, Tipochecklist, Equipos, Neumaticos } from '../../models/maestros';
import { ControlEquipoResult, ControlEquipoResultDetalle, ControlEquipoResultDetalleItem } from "../../models/ControlEquipoResult";
import { DataProvider } from '../../providers/data/data';
import { HomePage } from '../home/home';

import { Camera, CameraOptions } from "@ionic-native/camera";

/**
 * Generated class for the ControlEquiposDetallePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-control-equipos-detalle',
  templateUrl: 'control-equipos-detalle.html',
})
export class ControlEquiposDetallePage {


  private parameters: ControlEquiposDetalleParams;
  public equipos: Array<{ id: number, patente: string, detalles: CheckListCategory[], tractor: boolean }>;
  public selectedTab: any;
  public selectedEntry: any;
  public detalles: CheckListCategory[];

  //jhuck
  public mCountDetallesActivosEquipo: number;
  public mCountDetallesActivosAcoplado: number;
  public mDetalleIdAnteriorTractor: number;
  public mDetalleIdAnteriorAcoplado: number;
  public mNeumaticos: any;
  public mTractorActivo: boolean;

  //public mShowInfoNeumaticos: boolean;

  constructor(public navCtrl: NavController, navParams: NavParams, public alertCtrl: AlertController,
    private data: DataProvider, private cd: ChangeDetectorRef, public camara: Camera ) {

    this.mNeumaticos = [];
    this.parameters = navParams.data;

    this.buildBindData(this.parameters);

    this.mDetalleIdAnteriorTractor = 0;
    this.mDetalleIdAnteriorAcoplado = 0;
    this.mCountDetallesActivosEquipo = 0;
    this.mCountDetallesActivosAcoplado = 0;
    this.mTractorActivo = false;

    console.log("navParams: " , navParams.data);

  }

  public onSegmentChanged(evt) {
    this.selectEquipo(evt.value);
  }

  private selectEquipo(nombre: string) {

    this.selectedEntry = this.equipos.find(e => e.patente == nombre);
    this.detalles = this.selectedEntry.detalles;
    this.mNeumaticos =  this.buildNeumaticos(this.selectedEntry.neumaticos);

    this.cd.detectChanges();

    this.mTractorActivo = this.selectedEntry.tractor;

    console.log("selectEquipo: ", this.selectedEntry);
    //console.log("neumaticos: ", this.mNeumaticos);

  }

  private buildBindData(result: ControlEquiposDetalleParams) {

    let localEquipos = [];

    //primero obtenemos el listado de campos a mostrar
    this.data.getDetallesChecklist(result.result.checklist)
      .subscribe((tipoChecklist: Tipochecklist) => {

        //divido los controles entre los equipos a verificar
        //pueden ser 1 o 2
        if (this.parameters.equipo) {

          console.log("TipoCheck",tipoChecklist);
          //obtenengo los detalles que coresponden a este tipo de equipo
          let detalles = tipoChecklist.detalle.filter(d => d.tractor);

          localEquipos.push({ id: result.equipo.id, patente: result.equipo.patente,
            detalles: this.buildDetailsByCategory(detalles, 1), neumaticos: this.parameters.equipo.neumaticos, tractor: true,
            observaciones: this.parameters.equipo.observaciones });
        }

        console.log('parameters aco',this.parameters.acoplado);
        if (this.parameters.acoplado) {
          console.log('entra checklist aco',this.parameters.acoplado);
          //obtenengo los detalles que coresponden a este tipo de equipo
          let detalles = tipoChecklist.detalle.filter(d => d.acoplado);

          localEquipos.push({ id: result.acoplado.id, patente: result.acoplado.patente,
            detalles: this.buildDetailsByCategory(detalles, 2), neumaticos: this.parameters.acoplado.neumaticos, tractor: false,
            observaciones: this.parameters.equipo.observaciones });

        }

        this.equipos = localEquipos;

        console.log('localequiops',localEquipos);

        if(localEquipos.length>0){
          this.selectEquipo(localEquipos[0].patente);
        }

        //console.log( "buildDetailsByCategory: mCountDetallesActivosEquipo: ", this.mCountDetallesActivosEquipo );
        //console.log( "buildDetailsByCategory: mCountDetallesActivosAcoplado: ", this.mCountDetallesActivosAcoplado );
      });
  }

  /* --- */

  getInfoNeumaticos(neumatico, pos, consulta){
    //consulta: 1 == km // consulta: 2 == codigo
    let d: any;

    d = null;

    for( let i = 0; i< neumatico.data.length; i++ ){

      if( neumatico.data[i].posicion == pos ){
        //d = ( consulta == 1 ) ? neumatico.data[i].km + 'K' : neumatico.data[i].codigo;
        if( consulta == 1 ){

          if( neumatico.data[i].km != ""){
            d = neumatico.data[i].km + 'K';
          }

        } else {
          if( neumatico.data[i].codigo != "" ){
            d = neumatico.data[i].codigo;
          }
        }
        break;
      }
    }

    return d;
  }

  /* --- */

  private buildNeumaticos( neumaticos: any): Array<Neumaticos> {

    console.log( 'buildNeumaticos: ', neumaticos );

    let n = new Array();

    for( let i = 0; i< neumaticos.length; i++ ){
      if( neumaticos[i].data.length != 0 ){
        n.push(neumaticos[i]);
      }
    }

    return n;
  }

  /* --- */

  private buildDetailsByCategory(detalles: Detalle[], tipoequipo: number): Array<CheckListCategory> {

    let result = new Array<CheckListCategory>();
    let obs: any;

    if( tipoequipo == 1 ){ //equipo
      this.mCountDetallesActivosEquipo = detalles.length;
      obs = this.parameters.equipo.observaciones;
    } else {
      this.mCountDetallesActivosAcoplado = detalles.length;
      obs = this.parameters.acoplado.observaciones;
    }

    //console.log("buildDetailsByCategory: obs: ", obs);

    //ahora agrupamos los detalles por categoria
    for (var i = 0; i < detalles.length; i++) {


      var detalle = detalles[i];

      //busca si ya existe la categoria
      var existentCategory = result.find(d => d.nombre == detalle.categoria);
      if (!existentCategory) {
        existentCategory = new CheckListCategory();
        existentCategory.nombre = detalle.categoria;
        existentCategory.detalles = [];
       // existentCategory.previa = [];
        //existentCategory.previa = this.getObservacionPrevia(obs, detalle.id);

        result.push(existentCategory);
      }

      //console.log("buildDetailsByCategory: ", existentCategory);


      //agrego el item al detalle
      let categoryDetail = new CheckListCategoryDetail();
      categoryDetail.detalle = detalle;


      if(detalle.fk_tipocontrol == 6) //si es textbox, ponemos como valor default "false"
        categoryDetail.valor = null; //jhuck (false)


      let o = new CheckListCategoryDetail();
      o = this.getObservacionPrevia(obs, detalle.id);

      if( o.observacion != undefined){
        categoryDetail.observacion=o.observacion;
        categoryDetail.valor=false;
      }

      existentCategory.detalles.push(categoryDetail);


    }

    return result;

  }

  /* --- */

  showObservacionPrevia( detail, tipo ){  //tipo puede ser true/false. true = return string / false = return boolean TODO QUITAR

    let s = "";
    let obs: any;
    let esObsPrevia = false;

    if( this.mTractorActivo == true ){
      obs = this.parameters.equipo.observaciones;
    } else {
      obs = this.parameters.acoplado.observaciones;
    }

    obs.forEach( o => {

      //console.log("getObservacionPrevia: ids: ", o.fk_checklistdetalle, " :: ", detail.detalle.id );

      if( o.fk_checklistdetalle == detail.detalle.id ){
        s = o.observacion;
        esObsPrevia = true;
        //console.log("showObservacionPrevia: obs: ", s);
      }

    });

    //console.log("showObservacionPrevia: detail: ", s);

    return (tipo == true)? s : esObsPrevia;

  }
  /* --- */

  public getObservacionPrevia(obs: any, id: number): CheckListCategoryDetail{

    let previa = new CheckListCategoryDetail();

    obs.forEach( o => {

      //console.log("getObservacionPrevia: ids: ", o.fk_checklistdetalle, " :: ", id );

      if( o.fk_checklistdetalle == id ){
        previa.valor = o.valor;
        previa.observacion = o.observacion;
      }
    });

    //console.log("getObservacionPrevia: previa: ", previa);

    return previa;

  }

  public grabarDatos() {

    let result: any = {};

    //copiamos los datos de la cabecera
    this.parameters.result.uid = Math.random().toString(36).substr(2, 9);

    Object.assign(result, this.parameters.result);

    //agregamos los datelles
    result.detalles = this.convertDataToResult();

    // evalua si todos los controles tienen valor
    //console.log("grabarDatos: ", result );

    for( let d of result.detalles ){

      if( d.items.length != 0 ){

        for( let e of d.items ){
          console.log("grabarDatos: validacion: d.items:: ", e );
          if( e.valor == null){
            const alert = this.alertCtrl.create({
              title: 'Datos incompletos',
              subTitle: 'Debe completar los datos del tractor y/o del acoplado.',
              buttons: ['OK']
            });
            alert.present();
            return;
          }
        }
      }
    }

    //agregamos la imagen
    result.imageData = this.parameters.imageData;

    if(this.parameters.acoplado){
      result.acoplado = this.parameters.acoplado.id;
    }
    if(this.parameters.equipo){
      result.equipo = this.parameters.equipo.id;
    }

    result.requiererevisionmantenimiento = this.requiererevisionmant;

    console.log("resultado a enviar", result, JSON.stringify(result));

    this.data.addControlEquipo(result).subscribe(e => {
      let grabacion  = e;
      console.log("Resultado Grabacion",grabacion);
      if(grabacion['ok']){


        this.limpiarControles();
        this.data.sincronizarDatosControlEquipo().subscribe();

        this.navCtrl.push(HomePage);
      }
    });

  }

  /* --- */

  public limpiarControles(){
    //this.regresoViajeForm.controls.equipo.setValue(null);
    //this.regresoViajeForm.controls.viaje.setValue(null);
    //this.regresoViajeForm.controls.litros.setValue(null);
    //this.regresoViajeForm.controls.litrosformula.setValue(null);
    //this.regresoViajeForm.controls.kilometraje.setValue(null);
    //this.regresoViajeForm.controls.observacion.setValue(null);
    //this.regresoViajeForm.controls.consumo.setValue(null);
  }

  private convertDataToResult(): ControlEquipoResultDetalle[] {

    let detalles = [];

    this.equipos.forEach(e => {

      let detalle: ControlEquipoResultDetalle = {
        equipo: e.id,
        items: []
      };

      e.detalles.forEach(d => {

        //aplana las categorias
        d.detalles.forEach((m: CheckListCategoryDetail) => {

          console.log( 'convertDataToResult m:: ', m );

          //jhuck ACA evaluar si algun valor es NULL
          let mapItem: ControlEquipoResultDetalleItem = { numero: m.detalle.id,
                                                          valor: m.valor,
                                                          observacion: m.observacion, imagen: m.imagen,
                                                          //imagendata64: m.imagendata64
            };

          detalle.items.push(mapItem);
        });


      });

      detalles.push(detalle);
      console.log( 'convertDataToResult detalles:: ', detalles );

    });


    return detalles;
  }

  public marcarOk(detail,checked){

    /*
    console.log("marcarOk: this.mTractorActivo: ", this.mTractorActivo );
    console.log("marcarOk: detail.detalle.id: ", detail.detalle.id );
    console.log("marcarOk: this.mDetalleIdAnteriorTractor: ", this.mDetalleIdAnteriorTractor );
    console.log("marcarOk: this.mDetalleIdAnteriorAcoplado: ", this.mDetalleIdAnteriorAcoplado );
*/

    if( this.mTractorActivo == true ){

      if( detail.detalle.id != this.mDetalleIdAnteriorTractor ){
        this.mCountDetallesActivosEquipo--;
        this.mDetalleIdAnteriorTractor = detail.detalle.id;
      }

    } else {  //acoplado

      if( detail.detalle.id != this.mDetalleIdAnteriorAcoplado ){
        this.mCountDetallesActivosAcoplado--;
        this.mDetalleIdAnteriorAcoplado = detail.detalle.id;
      }

    }

    //console.log("marcarOk: this.mCountDetallesActivosEquipo: ", this.mCountDetallesActivosEquipo );
    //console.log("marcarOk: this.mCountDetallesActivosAcoplado: ", this.mCountDetallesActivosAcoplado );

    detail.valor = checked;

  }

  public requiererevisionmant = 0;

  public clickrequiererevision(event: any) {
    if(this.requiererevisionmant==0){
      this.requiererevisionmant = 1;
    }else{
      this.requiererevisionmant = 0;
    }
  }

  // ========

  public tomarFoto( detalle ){

    console.log( "tomarFoto iniciando");

    console.log( "tomarFoto equipo: ", this.equipos );

    let foto = "foto" + detalle.detalle.id + ".jpg";


    let options: CameraOptions = {
      destinationType: this.camara.DestinationType.DATA_URL,
      encodingType: this.camara.EncodingType.PNG,
      targetWidth: 700,
      targetHeight: 700,
      quality: 50
    }

    this.camara.getPicture( options )
      .then(pathToImage => {

        /*
        this.equipos.forEach(e => {

          e.detalles.forEach(d => {

            d.detalles.forEach((m: CheckListCategoryDetail) => {

              console.log( 'jh detalles id:: ', detalle.detalle.id );
              console.log( 'jh detalles:: ', m );

            });
          });
        });
        */

        detalle.imagen = pathToImage;
        // detalle.imagendata64 = 'data:image/png;base64,' + pathToImage;

        //console.log( "getPicture IMAGE: " + pathToImage );

      })
      .catch(error =>{
        console.error( "getPicture ERROR: " + error );
      });

  }

  // ===

}


export class ControlEquiposDetalleParams {

  result: ControlEquipoResult;

  equipo: Equipos;

  acoplado: Equipos;

  imageData: ImageData;

}


export class CheckListCategory {
  nombre: string;
  detalles: CheckListCategoryDetail[];

}

export class CheckListCategoryDetail {

  public detalle: Detalle;

  public valor: any;

  public observacion: string;

  public imagen: string;

 // public imagendata64: string;

}



// WEBPACK FOOTER //
// ./src/pages/control-equipos-detalle/control-equipos-detalle.ts